import React, { useEffect, useState } from "react";
import { hasPermission } from "../../utils/helper";
import { PERMISSION } from "../../utils/constants";
import CourierListPage, { CourierListHeadAction } from "./courier-list-page";
import CourierTable from "./ui/courier-table";

const camel = s => s.replace(/_([a-z])/g, (_m, c) => c.toUpperCase());

const ReportsList = props => {
  const {
    getCourierReports,
    reportsList = [],
    getCourierReport,
    report,
    courierLoading,
    resetCourierState
  } = props;

  const [slug, setSlug] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const canDownload = hasPermission(PERMISSION.CAN_DOWNLOAD_COURIER_REPORTS);

  useEffect(() => {
    getCourierReports();
    return () => resetCourierState();
  }, []);

  const run = chosen => {
    const s = chosen || slug;
    if (!s) return;
    const filters = {};
    if (dateFrom) filters.dateFrom = dateFrom;
    if (dateTo) filters.dateTo = dateTo;
    getCourierReport({ slug: s, filters });
  };

  const onSelect = e => {
    setSlug(e.target.value);
    run(e.target.value);
  };

  const exportCsv = () => {
    if (!report || !report.columns) return;
    const header = report.columns.map(c => c.label).join(",");
    const lines = (report.rows || []).map(row =>
      report.columns
        .map(c => {
          const value = row[camel(c.key)];
          const cell = value == null ? "" : String(value);
          return cell.includes(",") ? `"${cell}"` : cell;
        })
        .join(",")
    );
    const csv = [header, ...lines].join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${report.slug || "report"}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <CourierListPage
      title="Courier Reports"
      count={reportsList.length}
      loading={courierLoading}
      headActions={
        canDownload &&
        report &&
        report.columns && (
          <CourierListHeadAction label="Export CSV" onClick={exportCsv} />
        )
      }
    >
      <div className="list-search-area">
        <div className="id-search-form">
          <select value={slug} onChange={onSelect}>
            <option value="">Select report</option>
            {reportsList.map(r => (
              <option key={r.slug} value={r.slug}>
                {r.title}
              </option>
            ))}
          </select>
          <input
            type="date"
            value={dateFrom}
            onChange={e => setDateFrom(e.target.value)}
          />
          <input
            type="date"
            value={dateTo}
            onChange={e => setDateTo(e.target.value)}
          />
          <button type="button" className="search-btn" onClick={() => run()}>
            <i className="icon-magnify" />
          </button>
        </div>
      </div>

      {report && report.columns && (
        <>
          <h3 className="courier-subhead">{report.title}</h3>
          <CourierTable>
            <thead>
              <tr>
                {report.columns.map(c => (
                  <th key={c.key}>{c.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(report.rows || []).map((row, idx) => (
                <tr key={idx}>
                  {report.columns.map(c => {
                    const value = row[camel(c.key)];
                    return (
                      <td key={c.key}>
                        {value == null ? "—" : String(value)}
                      </td>
                    );
                  })}
                </tr>
              ))}
              {!(report.rows || []).length && (
                <tr>
                  <td colSpan={report.columns.length}>No data.</td>
                </tr>
              )}
            </tbody>
          </CourierTable>
        </>
      )}
    </CourierListPage>
  );
};

export default ReportsList;
